import React from 'react';
import config from '../../config';

function BlogsPageHeader() {
  return (
    <section className="page-header">
      <div 
        className="page-header-bg" 
        style={{ backgroundImage: "url(assets/images/backgrounds/blogpage-Header-1894-434.jpg)" }}
      >
      </div>
      <div className="container">
        <div className="page-header__inner">
          <h2>Blogs</h2>
          <ul className="thm-breadcrumb list-unstyled">
                        <li><a href="/">Home</a></li>
                        <li><span>/</span></li>
                        <li><a href="">Blogs</a></li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default BlogsPageHeader;